import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { api, formatDate } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const SiteHeader = () => {
  const [cats, setCats] = useState([]);
  const { user } = useAuth();
  useEffect(() => { api.get("/categories").then((r) => setCats(r.data)).catch(() => {}); }, []);
  const tab = ({ isActive }) =>
    `whitespace-nowrap py-3 text-sm font-semibold border-b-2 transition-colors ${isActive ? "border-[#C8102E] text-[#C8102E]" : "border-transparent text-slate-600 hover:text-slate-900"}`;

  return (
    <header className="sticky top-0 z-30 bg-white/90 backdrop-blur-md border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 flex items-center justify-between py-4">
        <Link to="/" data-testid="site-logo" className="font-serif text-2xl sm:text-3xl font-extrabold tracking-tight text-slate-950">
          Kabar<span className="text-[#C8102E]">Nusa</span>
        </Link>
        <div className="flex items-center gap-4">
          <span className="hidden md:block text-xs text-slate-500">{formatDate(new Date().toISOString())}</span>
          <Link to={user ? "/admin/berita" : "/admin/login"} data-testid="header-admin-link"
            className="text-xs font-bold uppercase tracking-widest px-4 py-2 bg-slate-950 text-white hover:bg-[#C8102E] transition-colors">
            {user ? "Dasbor" : "Admin"}
          </Link>
        </div>
      </div>
      <nav className="max-w-7xl mx-auto px-4 sm:px-8 flex gap-6 overflow-x-auto no-scrollbar">
        <NavLink to="/" end className={tab} data-testid="nav-cat-all">Terbaru</NavLink>
        {cats.map((c) => (
          <NavLink key={c.id} to={`/kategori/${c.slug}`} className={tab} data-testid={`nav-cat-${c.slug}`}>{c.name}</NavLink>
        ))}
      </nav>
    </header>
  );
};

export const SiteFooter = () => (
  <footer className="mt-24 bg-slate-950 text-slate-400">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-12 flex flex-col sm:flex-row justify-between gap-4">
      <span className="font-serif text-xl text-white font-bold">Kabar<span className="text-[#C8102E]">Nusa</span></span>
      <span className="text-sm">© {new Date().getFullYear()} KabarNusa. Portal berita terpercaya.</span>
    </div>
  </footer>
);
